import React, { useContext, useEffect } from "react";
import { useState } from "react";
import Select from "react-select/creatable";
import classes from "./DeliveryReport.module.css";
import axios from "../../../../Axios/Axios";
import { Urls } from "../../../../Urls";
import { toast } from "react-toastify";
import { DateFormatter1, DateFormatter2 } from "../../../../Constants";
import Loader from "../../../Loader/Loader";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

export const DownloadReports = ({ days, bucket, level, screen }) => {
  const [startDate, setStartDate] = useState();
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [endDate, setEndDate] = useState();
  const [currentDate, setCurrentDate] = useState();
  const [intervalDays, setIntervalDays] = useState(days);
  const [enquiryBucket, setEnquiryBucket] = useState(bucket);
  const [enquiryLevel, setEnquiryLevel] = useState(level);
  const [reportData, setReportData] = useState();
  const [show, setshow] = useState(false);
  const [max_range, setmax_range] = useState();
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );

  const iscompanycheck =
    userDetails?.policy?.adhoc?.allowed_view_company_enquiries === "yes";

  useEffect(() => {
    // Initialize default dates and fetch initial reports
    var dt = new Date();
    dt.setDate(dt.getDate() - intervalDays);
    const ninetydays = new Date();
    ninetydays.setDate(ninetydays.getDate() - 90);
    if (dt < ninetydays) {
      dt = ninetydays;
    }
    var day1 = ("0" + dt.getDate()).slice(-2);
    var month1 = ("0" + (dt.getMonth() + 1)).slice(-2);
    var year1 = dt.getFullYear();
    var previousDate =
      year1.toString() + "-" + month1.toString() + "-" + day1.toString();
    setStartDate(startDate ? startDate : previousDate);

    var rangeDate = new Date();
    rangeDate.setDate(rangeDate.getDate() - 90);
    var day2 = ("0" + rangeDate.getDate()).slice(-2);
    var month2 = ("0" + (rangeDate.getMonth() + 1)).slice(-2);
    var year2 = rangeDate.getFullYear();
    var range =
      year2.toString() + "-" + month2.toString() + "-" + day2.toString();
    setmax_range(range);

    var mindate = new Date();
    var day = ("0" + mindate.getDate()).slice(-2);
    var month = ("0" + (mindate.getMonth() + 1)).slice(-2);
    var year = mindate.getFullYear();
    var todaydate =
      year.toString() + "-" + month.toString() + "-" + day.toString();
    setEndDate(todaydate);
    setCurrentDate(todaydate);
    getReports();
  }, []);

  /**
   * Fetches the reports based on the selected screen.
   */
  const getReports = () => {
    if (screen === "spot") {
      setshow(true);
      axios
        .get(`${Urls.report_generator}/report_generator?module=spot`)
        .then((res) => {
          setshow(false);
          setReportData(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  /**
   * Formats a date value to UTC string.
   *
   * @param {string} value - The date value to format.
   * @returns {string} The formatted UTC date string.
   */
  const UTCFormatter = (value) => {
    var newDate = new Date(value);
    return newDate.toISOString();
  };

  /**
   * Formats a date value to UTC string with end-of-day time.
   *
   * @param {string} value - The date value to format.
   * @returns {string} The formatted UTC date string with end-of-day time.
   */
  const UTCFormatter1 = (value) => {
    var newDate = new Date(value);
    var str = newDate.toISOString().split("T")[0];
    var time = "T23:59:59Z";
    var finalUrl = str + time;
    return finalUrl;
  };

  /**
   * Handles the submission of the report generation request.
   */
  const submitHandler = () => {
    if (screen === "spot") {
      var payload = {
        activity: "Report Generation Request",
        module: "spot",
        filters: {
          from: UTCFormatter(startDate),
          to: UTCFormatter1(endDate),
          view: enquiryLevel,
          bucket: enquiryBucket,
        },
        report_status: "pending",
        email: `${localStorage.getItem("useremail")}`,
      };

      var spot_payload = {
        bucket: enquiryBucket,
        from: UTCFormatter(startDate),
        to: UTCFormatter1(endDate),
        email: `${localStorage.getItem("useremail")}`,
        enquiry_view: enquiryLevel,
        skip: 0,
        limit: 3,
      };

      const fromDate = new Date(startDate);
      const toDate = new Date(endDate);
      const diffInDays = Math.floor(
        (toDate - fromDate) / (1000 * 60 * 60 * 24),
      );

      if (diffInDays <= 90) {
        TrackMixPanel({
          ModuleName: "lorri spot",
          ScreenName: "my enquiries - report generator",
          Data: `from : ${spot_payload.from}, to : ${spot_payload.to}, bucket: ${spot_payload.bucket}, enquiry view: ${spot_payload.enquiry_view}`,
          Definition: "user has generated enquiries report",
        });
        axios
          .post(
            `${Urls.spot}?field=logistics_enquiry&email=${localStorage.getItem(
              "useremail",
            )}`,
            spot_payload,
          )
          .then((res) => {
            if (
              res.data &&
              res.data.enquiry_list &&
              res.data.enquiry_list.length > 0
            ) {
              setshow(false);
              axios
                .post(`${Urls.logURL}`, payload)
                .then((response) => {
                  toast.success(
                    "You will be notified via email once the report is generated",
                  );
                  getReports();
                })
                .catch((err) => {
                  console.log(err);
                });
            } else {
              setshow(false);
              toast.info("No Enquiries Found");
            }
          })
          .catch((error) => {
            setshow(false);
            console.log(error);
          });
      } else {
        toast.info("Please select a 3-month interval");
      }
    }
  };

  /**
   * Handles the report download.
   *
   * @param {Object} data - The report data.
   */
  const downloadReport = (data) => {
    setshow(true);
    if (data && data.blob_uri) {
      setshow(false);
      window.open(data.blob_uri, "_parent");
    } else {
      setshow(false);
      toast.error("Please try again later!");
    }
  };

  /**
   * Formats a date string for display.
   *
   * @param {string} dateString - The date string to format.
   * @returns {string} The formatted date string.
   */
  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="px-4" id="report-generator">
      <Loader show={show} />
      <div
        className={`d-flex justify-content-between ${classes["input-fields"]} mt-2`}
      >
        <div>
          <label>From</label>
          <br />
          <div style={{ width: "95%" }}>
            <input
              type="date"
              defaultValue={startDate}
              min={max_range}
              max={endDate}
              style={{ height: "38px" }}
              onInput={(e) => {
                setStartDate(e.target.value);
              }}
            ></input>
          </div>
        </div>
        <div>
          <label>To</label>
          <br />
          <div style={{ width: "95%" }}>
            <input
              type="date"
              defaultValue={endDate}
              min={startDate}
              max={currentDate}
              style={{ height: "38px" }}
              onInput={(e) => {
                // console.log(e.target.value, 'to')
                setEndDate(e.target.value);
                var newDate = new Date(e.target.value);
                newDate.setDate(newDate.getDate() - 90);
                var day = ("0" + newDate.getDate()).slice(-2);
                var month = ("0" + (newDate.getMonth() + 1)).slice(-2);
                var year = newDate.getFullYear();
                var range =
                  year.toString() +
                  "-" +
                  month.toString() +
                  "-" +
                  day.toString() +
                  "";
                setmax_range(range);
              }}
            ></input>
          </div>
        </div>
        <div className={`${classes["select-options"]}`}>
          {screen === "spot" ? (
            <>
              <label>Enquiry Type</label>
              <Select
                options={[
                  { label: "All Enquiries", value: "all" },
                  { label: "Active Enquiry", value: "active" },
                  { label: "Approved Enquiry", value: "approved" },
                  { label: "Archived Enquiry", value: "expired" },
                  { label: "Cancelled Enquiry", value: "cancelled" },
                ]}
                onChange={(e) => {
                  setEnquiryBucket(e.value);
                }}
                isSearchable={false}
                isMulti={false}
                value={
                  enquiryBucket === "active"
                    ? { label: "Active Enquiry", value: "active" }
                    : enquiryBucket === "approved"
                      ? { label: "Approved Enquiry", value: "approved" }
                      : enquiryBucket === "expired"
                        ? { label: "Archived Enquiry", value: "expired" }
                        : enquiryBucket === "cancelled"
                          ? { label: "Cancelled Enquiry", value: "cancelled" }
                          : enquiryBucket === "all"
                            ? { label: "All Enquiries", value: "all" }
                            : ""
                }
              />
            </>
          ) : null}
        </div>
        <div className={`${classes["select-options"]}`}>
          {screen === "spot" && iscompanycheck ? (
            <>
              <label>User Type</label>
              <Select
                options={[
                  { label: "My Enquiries", value: "user_view" },
                  { label: "Company Enquiries", value: "company_view" },
                ]}
                onChange={(e) => {
                  setEnquiryLevel(e.value);
                }}
                isSearchable={false}
                isMulti={false}
                classNamePrefix={"Truck_Prefix"}
                value={
                  enquiryLevel === "user_view"
                    ? { label: "My Enquiries", value: "user_view" }
                    : enquiryLevel === "company_view"
                      ? { label: "Company Enquiries", value: "company_view" }
                      : ""
                }
              />
            </>
          ) : null}
        </div>
        <button
          className={`btn btn-sm btn-primary ${classes["submit-button"]}`}
          onClick={submitHandler}
        >
          Submit
        </button>
        {/* </div> */}
      </div>

      <p></p>
      <div className={`mt-5 border ${classes["report-table"]}`}>
        <table className={`table table-borderless ${classes["report-head"]}`}>
          <thead>
            <tr>
              <th className="text-center">Sr. No.</th>
              <th className="text-center">Requested Data</th>
              <th className="text-center">Requested On</th>
              <th className="text-center">Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody className={`${classes["report-body"]}`}>
            {reportData && reportData.length > 0 ? (
              reportData.map((data, index) => {
                return (
                  <tr>
                    <td>{index + 1}.</td>
                    <td>
                      {screen === "spot" ? (
                        <>
                          <div>
                            {data?.filters?.bucket === "active" ? (
                              <div>
                                Active Enquiry -{" "}
                                {data?.filters?.view === "user_view"
                                  ? "User"
                                  : "Company"}
                              </div>
                            ) : data?.filters?.bucket === "approved" ? (
                              <div>
                                Approved Enquiry -{" "}
                                {data?.filters?.view === "user_view"
                                  ? "User"
                                  : "Company"}
                              </div>
                            ) : data?.filters?.bucket === "all" ? (
                              <div>
                                All Enquiries -{" "}
                                {data?.filters?.view === "user_view"
                                  ? "User"
                                  : "Company"}
                              </div>
                            ) : data?.filters?.bucket === "expired" ? (
                              <div>
                                Archived Enquiry -{" "}
                                {data?.filters?.view === "user_view"
                                  ? "User"
                                  : "Company"}
                              </div>
                            ) : data?.filters?.bucket === "cancelled" ? (
                              <div>
                                Cancelled Enquiry -{" "}
                                {data?.filters?.view === "user_view"
                                  ? "User"
                                  : "Company"}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <hr className={`${classes["dash-line"]}`} />
                          {/* <div className='border'>{DateFormatter1(data.filters.from)}</div> */}
                          <div>{`${DateFormatter2(
                            data?.filters?.from.split("T")[0],
                          )} to ${DateFormatter2(
                            data?.filters?.to.split("T")[0],
                          )}`}</div>
                        </>
                      ) : (
                        <div>{`${formatDate(
                          data?.filters?.from.split("T")[0],
                        )} to ${formatDate(
                          data?.filters?.to.split("T")[0],
                        )}`}</div>
                      )}
                    </td>
                    <td>{DateFormatter1(data.timestamp)}</td>
                    <td>
                      {data?.report_status === "pending" ? (
                        <div>In Progress</div>
                      ) : data?.report_status === "success" ? (
                        <div>Completed</div>
                      ) : data?.report_status === "failed" ? (
                        <div>Failed</div>
                      ) : (
                        ""
                      )}
                    </td>
                    <td className="text-left">
                      {data && data?.report_status === "success" ? (
                        <button
                          className={`btn btn-sm btn-success ${classes["download-report"]}`}
                          onClick={(e) => downloadReport(data)}
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td></td>
                <td>No Reports</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <p className={`font-italic ${classes["view-note"]}`}>
        Note: The generated report will be available for 24Hrs from time of
        generation
      </p>
    </div>
  );
};
